import { gql } from 'graphql-tag';

export const GET_DEVICES = gql`
  query devices {
    devices {
      id
      name
      store {
        id
      }
      deviceProfile {
        id
        name
        isDefault
        orderTypes {
          id
          name
          code
        }
        defaultOrderType {
          id
          name
          code
        }
        customerDisplay {
          brandColor
          theme
          idleScreen {
            logoUri
            mediaType
            assets {
              position
              uri
            }
          }
          cartScreen {
            logoUri
            mediaType
            assets {
              position
              uri
            }
          }
        }
      }
      customerDisplay {
        id
        name
        isPaired
        lastLoginAt
      }
      mode
      linkCdsToPayApp
      enableTap2PayEmbedded
      tap2PayDisplaySettings {
        enableRotation
        nfcKioskPosition
        pinAlignment
      }
    }
  }
`;
